<template>
  <div
    class="modal fade show opacity-100 modal p-3 d-flex align-items-center justify-content-center"
    @click="close"
  >
    <div
      class="modal-dialog modal-fullscreen bg-white rounded"
      style="height: calc(100vh - 50px); width: calc(100vw - 50px)"
      @click.stop
    >
      <div class="modal-content position-relative rounded">
        <div class="carousel carousel-dark slide h-100 rounded">
          <div class="carousel-inner w-100 h-100 rounded">
            <img
              class="carousel-item active img-cover w-100 h-100 rounded"
              :src="current.src"
              :title="current.title"
            />
          </div>

          <div class="carousel-indicators">
            <button
              v-for="(image, index) in images"
              :key="index"
              :class="{ active: image.src == current.src }"
              data-bs-target
              :title="image.title"
              type="button"
              @click="goto(index)"
            ></button>
          </div>

          <button
            class="carousel-control-prev"
            type="button"
            @click.prevent="prev"
          >
            <span class="carousel-control-prev-icon"></span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            @click.prevent="next"
          >
            <span class="carousel-control-next-icon"></span>
          </button>
        </div>

        <button
          class="btn-close position-absolute top-0 end-0 mx-4 my-4 p-2 rounded-circle border bg-light z-3"
          :title="translations.actions.CLOSE"
          type="button"
          @click="close"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { filter, first, length, map, merge } from "@pdfking/rfunc"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import { make_absolute_url } from "@pdfking/workflow/utils/urlutilities"

import selector from "../../dom/selector"
import close from "../../mixins/close"
import freeze from "../../mixins/freeze"
import keyboard from "../../state/keyboard"
import navigate from "../navigate"
import { SLIDESHOW_VIEW } from "../urls"
export default {
  mixins: [close, freeze],
  props: ["selector", "selected"],
  data() {
    return {
      toggled_class: "modal-body",
    }
  },
  watch: {
    up_pressed(v) {
      if (v) this.prev()
    },
    down_pressed(v) {
      if (v) this.next()
    },
    left_pressed(v) {
      if (v) this.prev()
    },
    right_pressed(v) {
      if (v) this.next()
    },
  },
  methods: {
    goto(position) {
      let next = position

      if (next + 1 > length(this.images)) next = 0
      if (next < 0) next = length(this.images) - 1

      navigate(SLIDESHOW_VIEW, {
        selector: this.selector,
        selected: this.images[next].src,
      })
    },
    next() {
      this.goto(this.current_index + 1)
    },
    prev() {
      this.goto(this.current_index - 1)
    },
  },

  computed: merge(
    proxy(keyboard, {
      ARROW_LEFT: "left_pressed",
      ARROW_UP: "up_pressed",
      ARROW_DOWN: "down_pressed",
      ARROW_RIGHT: "right_pressed",
    }),

    {
      translations: () => make_translations(["actions"]),
      images() {
        return this.selector
          ? map(
              e => ({
                title: e.title,
                description: e.alt,
                src: make_absolute_url(
                  e.getAttribute("data-slide-src") || e.src
                ),
              }),
              selector(this.selector)
            )
          : []
      },
      current() {
        const target = make_absolute_url(this.selected)
        return (
          first(filter(e => e.src == target, this.images)) || first(this.images)
        )
      },
      current_index() {
        return this.images.indexOf(this.current)
      },
    }
  ),
}
</script>
